import { useEffect } from "react";
import { PageUid, useCustomisation } from "../context/CustomisationContext";
import { usePortal } from "../context/PortalsContext";
import { useAuth } from "../context/AuthContext";
import { hasSomeCustomisation } from "../utils/helpers";

export const usePageCustomisation = (pageUid: PageUid): void => {
  const { customisations, updateCustomisations } = useCustomisation();
  const { portals } = usePortal();
  const { auth } = useAuth();

  const isCached = hasSomeCustomisation(
    customisations.customisations,
    pageUid,
  );

  useEffect(() => {
    // Wait for auth state to settle.
    if (auth.loadStatus !== "loaded") return;

    // Authenticated path needs a selected portal before fetching.
    if (auth.user && !portals.selectedPortal) return;

    // Already cached for this portal/page — nothing to do.
    if (isCached) return;

    updateCustomisations(pageUid);
    // updateCustomisations branches internally:
    //   - guest: getDesignByUrl(pageUid, window.location.origin)
    //   - auth:  getPageDesign(selectedPortal.portalUid, pageUid)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    pageUid,
    auth.loadStatus,
    auth.user,
    portals.selectedPortal?.portalUid,
    isCached,
  ]);
};
